import React, { useState } from 'react';
import './UserBenefits.css';
// eslint-disable-next-line
import { NextArrow } from '../../../../imports';

const UserBenefits = () => {
  const [activeTab, setActiveTab] = useState('memberships');

  // Mock data for demonstration - replace with actual API calls
  // Structured similar to Memberships.jsx
  const memberships = [
    {
      id: 1,
      membership_type: 'Premium Sedan',
      price: 99,
      start_date: '2023-05-15',
      end_date: '2024-05-15',
      status: 'active',
      benefits: ['Priority Booking', 'Monthly Detail', '10% Off Additional Services']
    },
    {
      id: 2,
      membership_type: 'Premium Truck/Medium SUV',
      price: 119,
      start_date: '2022-01-10',
      end_date: '2023-01-10',
      status: 'expired',
      benefits: ['Quarterly Detail', '5% Off Additional Services']
    }
  ];

  // Mock data for gift cards - structured similar to GiftCards.jsx
  const giftCards = [
    {
      id: 101,
      code: 'GC-2023-1234',
      amount: 100,
      balance: 75,
      expiryDate: '2024-12-31',
      status: 'active'
    },
    {
      id: 102,
      code: 'GC-2023-5678',
      amount: 50,
      balance: 0,
      expiryDate: '2023-06-30',
      status: 'used'
    }
  ];

  const renderMemberships = () => {
    if (memberships.length === 0) {
      return (
        <div className="user-benefits__no-items">
          <p>You don't have any memberships yet.</p>
          <button className="user-benefits__cta-button">Explore Memberships</button>
        </div>
      );
    }

    return (
      <div className="memberships-list">
        {memberships.map(membership => (
          <div 
            key={membership.id} 
            className={`membership-item ${membership.status === 'active' ? 'active' : 'expired'}`}
          >
            <div className="membership-info">
              <h4>{membership.membership_type}</h4>
              <p className="price">${membership.price}/month</p>
              <p className="date">Start Date: {new Date(membership.start_date).toLocaleDateString()}</p>
              <p className="date">End Date: {new Date(membership.end_date).toLocaleDateString()}</p>
              
              <div className="membership-benefits">
                <h5>Benefits:</h5>
                <ul>
                  {membership.benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div className="membership-actions">
              <span className={`status-badge status-${membership.status}`}>
                {membership.status.charAt(0).toUpperCase() + membership.status.slice(1)}
              </span>
              
              {/* {membership.status === 'active' && (
                <button className="action-button">
                  Manage Membership <NextArrow className="icon" />
                </button>
              )}
              
              {membership.status === 'expired' && (
                <button className="action-button renew">
                  Renew Membership <NextArrow className="icon" />
                </button>
              )} */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderGiftCards = () => {
    if (giftCards.length === 0) {
      return (
        <div className="user-benefits__no-items">
          <p>You don't have any gift cards.</p>
          <button className="user-benefits__cta-button">Purchase Gift Card</button>
        </div>
      );
    }

    return (
      <div className="gift-cards-list">
        {giftCards.map(giftCard => (
          <div 
            key={giftCard.id} 
            className={`gift-card-item ${giftCard.status === 'active' ? 'active' : 'used'}`}
          >
            <div className="gift-card-inner">
              <div className="gift-card-front">
                <div className="gift-card-chip"></div>
                <h3>Gift Card</h3>
                <div className="gift-card-price">
                  <span>$</span>
                  <span className="amount">{giftCard.amount}</span>
                </div>
                <p className="gift-card-balance">Current Balance: ${giftCard.balance.toFixed(2)}</p>
                <p className="gift-card-code">{giftCard.code}</p>
              </div>
              
              <div className="gift-card-details">
                <div className="gift-card-info">
                  <p><strong>Original Amount:</strong> ${giftCard.amount.toFixed(2)}</p>
                  <p><strong>Current Balance:</strong> ${giftCard.balance.toFixed(2)}</p>
                  <p><strong>Expires:</strong> {new Date(giftCard.expiryDate).toLocaleDateString()}</p>
                  <p><strong>Card Code:</strong> {giftCard.code}</p>
                </div>
                
                <div className="gift-card-actions">
                  <span className={`status-badge status-${giftCard.status}`}>
                    {giftCard.status.charAt(0).toUpperCase() + giftCard.status.slice(1)}
                  </span>
                  
                  {/* {giftCard.status === 'active' && (
                    <button className="action-button">
                      Use Gift Card <NextArrow className="icon" />
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="user-benefits">
      <div className="user-benefits__tabs">
        <button 
          className={`user-benefits__tab ${activeTab === 'memberships' ? 'user-benefits__tab--active' : ''}`}
          onClick={() => setActiveTab('memberships')}
        >
          Memberships
        </button>
        <button 
          className={`user-benefits__tab ${activeTab === 'giftcards' ? 'user-benefits__tab--active' : ''}`}
          onClick={() => setActiveTab('giftcards')}
        >
          Gift Cards
        </button>
      </div>
      
      <div className="user-benefits__content">
        {activeTab === 'memberships' ? renderMemberships() : renderGiftCards()}
      </div>
    </div>
  );
};

export default UserBenefits;
